import React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, AlertTriangle, Clock, Ban, ChevronRight } from "lucide-react";

const STATUS_CONFIG = {
  compliant: { label: "Complert", icon: CheckCircle2, color: "text-emerald-600", bg: "bg-emerald-50", badge: "bg-emerald-100 text-emerald-700" },
  pending: { label: "Pendent", icon: Clock, color: "text-amber-600", bg: "bg-amber-50", badge: "bg-amber-100 text-amber-700" },
  non_compliant: { label: "Incomplert", icon: AlertTriangle, color: "text-red-600", bg: "bg-red-50", badge: "bg-red-100 text-red-700" },
  not_applicable: { label: "N/A", icon: Ban, color: "text-gray-400", bg: "bg-gray-50", badge: "bg-gray-100 text-gray-500" },
};

export default function ComplianceAreaCard({ area, items, onClick }) {
  const compliant = items.filter(i => i.status === "compliant").length;
  const pending = items.filter(i => i.status === "pending").length;
  const nonCompliant = items.filter(i => i.status === "non_compliant").length;
  const applicable = items.filter(i => i.status !== "not_applicable").length;
  const pct = applicable > 0 ? Math.round((compliant / applicable) * 100) : null;

  const barColor = pct === null ? "bg-gray-200" : pct >= 80 ? "bg-emerald-500" : pct >= 50 ? "bg-amber-400" : "bg-red-500";
  const pctColor = pct === null ? "text-gray-400" : pct >= 80 ? "text-emerald-600" : pct >= 50 ? "text-amber-600" : "text-red-600";

  return (
    <Card
      onClick={onClick}
      className="p-5 border-0 shadow-sm hover:shadow-md transition-all cursor-pointer group"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`w-11 h-11 rounded-xl flex items-center justify-center text-xl ${area.bg}`}>
            {area.icon}
          </div>
          <div>
            <h3 className="font-bold text-gray-900 text-sm">{area.label}</h3>
            <p className="text-xs text-gray-400">{items.length} obligacions</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className={`text-2xl font-bold ${pctColor}`}>{pct !== null ? `${pct}%` : "—"}</span>
          <ChevronRight className="w-4 h-4 text-gray-300 group-hover:text-gray-500 transition-colors" />
        </div>
      </div>

      <div className="w-full bg-gray-100 rounded-full h-2 mb-3">
        <div className={`h-2 rounded-full transition-all ${barColor}`} style={{ width: pct !== null ? `${pct}%` : "0%" }} />
      </div>

      <div className="flex gap-2 flex-wrap">
        {compliant > 0 && (
          <span className="text-[11px] bg-emerald-100 text-emerald-700 rounded-full px-2 py-0.5 font-medium">
            ✓ {compliant} complerts
          </span>
        )}
        {pending > 0 && (
          <span className="text-[11px] bg-amber-100 text-amber-700 rounded-full px-2 py-0.5 font-medium">
            ⏳ {pending} pendents
          </span>
        )}
        {nonCompliant > 0 && (
          <span className="text-[11px] bg-red-100 text-red-700 rounded-full px-2 py-0.5 font-medium">
            ✗ {nonCompliant} incomplerts
          </span>
        )}
        {items.length === 0 && (
          <span className="text-[11px] text-gray-400">Sense registres</span>
        )}
      </div>
    </Card>
  );
}